import {
    getComputedSelectedRowKeysSize,
    getComputedIsInVirtualSelectAllMode,
} from 'owa-mail-list-store';
import { getActiveContentTab, TabType } from 'owa-tab-store';
import { getCurrentModule } from 'owa-app-module-store';
import { Module } from 'owa-workloads-module';

/**
 * True when the mail reading pane is showing nothing meaningful — no selection, not in
 * virtual select-all, and compose isn't active (compose renders in the RP area). Returns
 * false outside the Mail module since other modules don't have a mail reading pane.
 */
export function isReadingPaneEmpty(): boolean {
    return (
        getCurrentModule() === Module.Mail &&
        getComputedSelectedRowKeysSize() === 0 &&
        !getComputedIsInVirtualSelectAllMode() &&
        getActiveContentTab()?.type !== TabType.MailCompose
    );
}
